import { useMutation, useQueryClient } from '@tanstack/react-query';
import { blockedUsersApi } from '../api/blockedUsers.api';
import { blockedUsersKeys } from '../api/blockedUsers.keys';
import toast from 'react-hot-toast';

export function useCreateBlockedUser() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: any) => blockedUsersApi.create(data),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: blockedUsersKeys.all });
      toast.success('User blocked successfully');
    },
    onError: (err: any) => {
      toast.error(err.response?.data?.message || 'Failed to block user');
    },
  });
}

export function useDeleteBlockedUser() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: any) => blockedUsersApi.delete(id),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: blockedUsersKeys.all });
      toast.success('Block removed');
    },
    onError: (err: any) => {
      toast.error(err.response?.data?.message || 'Failed to remove block');
    },
  });
}
